<template>
  <div>
    <br>
    <br>
    <el-row>
      <el-col :sm="3" style="padding-top: 10px">
        <el-button size="mini" icon="el-icon-arrow-left" @click="m__back_to_list">{{ $t('base.back') }}</el-button>
      </el-col>
      <el-col :sm="11">
        <p style="font-size: 18px">{{ $t('flash_sale.create_title') }}</p>
        <span style="color: #999999">{{ $t('flash_sale.you_have_enabled') }} {{ product_list.length }}/10
          {{ $t('flash_sale.products_for_selected_time_slots') }}.</span>
      </el-col>
      <el-col :sm="10" style="padding-top: 10px">
        <p style="font-weight: bold; font-size: 14px">{{ $t('flash_sale.live_period') }}</p>
        <small style="color: #666">{{ m__first_text() }}</small><br>
        <small style="color: #666">{{ m__second_text() }}</small>
      </el-col>
    </el-row>

    <div style="margin-top: 20px">
      <table class="table">
        <thead>
        <tr style="background-color: #f5f5f5">
          <td style="padding: 20px 0; text-align: left"></td>
          <td style="padding: 20px 0; text-align: left">{{ $t('base.variation') }}</td>
          <th>
            {{ $t('base.variation_price') }}
          </th>
          <th>{{ $t('base.discounted_price') }}</th>
          <th>{{ $t('base.discount') }}</th>
          <th>{{ $t('flash_sale.campaign_stock') }}</th>
          <th>{{ $t('base.stock') }}</th>
          <th>{{ $t('flash_sale.purchase_limit') }}</th>
          <td style="padding: 20px 0; text-align: left">{{ $t('flash_sale.enable_disable') }}</td>
        </tr>
        </thead>
        <tbody>
        <template v-if="loading.get_data">
          <tr>
            <td style="text-align: center;" colspan="9">
              <div style="padding-top: 20px">
                <i class="el-icon-loading"></i><strong> {{ $t('base.loading_data') }}</strong>
              </div>
            </td>
          </tr>
        </template>
        <template v-else>
          <template v-for="item in product_list">
            <tr>
              <td>
                <div style="height: 5px"></div>
              </td>
            </tr>
            <tr>
              <td style="width: 50px">
                <img :src="SHOPEE_IMAGE(item.images[0])" alt="logo"
                     style="width:35px; height: 35px;">
              </td>
              <td colspan="8">
                <a href="javascript:void(0)"
                   @click="open_link_fixed(`https://shopee.com/product-i.${seller ? seller.shop_id : ''}.${item.id}`, shop)">
                  {{ item.name }}
                </a>
              </td>
            </tr>
            <tr v-for="model in item.model_list"
                :class="model.batch && model.batch.status === 0 ? 'disabled-text' : ''">
              <td></td>
              <td>{{ model.name }}</td>
              <td>{{ m__calculate(model.price_info.normal_price) | currency }} {{ m__currency() }}</td>
              <td>{{ m__calculate(model.batch.promotion_price) | currency }} {{ m__currency() }}</td>
              <td>
              <span :style="model.batch.status === 0 ? 'color: #ccccd6' : 'color: orangered'">
              {{
                  m__calculate(100 - m__calculate(model.batch.promotion_price) * 100 / m__calculate(model.price_info.normal_price))
                }}% {{ $t('flash_sale.discount') }}</span>
              </td>
              <td style="width: 100px">{{ model.batch.stock }}</td>
              <td>{{ model.batch.quantity }}</td>
              <td>
                <template v-if="model.batch.purchase_limit > 0">{{ model.batch.purchase_limit }}</template>
                <template v-else>{{ $t('base.unlimited') }}</template>
              </td>
              <td>
                {{ model.batch.status === 1 ? $t('base.enable') : $t('base.disable') }}
              </td>
            </tr>
          </template>
        </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {fix_ads_mixins} from "../../mixins/fix_ads";

export default {
  name: 'page__flash_sale_detail',

  mixins: [fix_ads_mixins],

  props: {
    seller: null,
    flash_sale: null,
    shop: null
  },

  data() {
    return {
      loading: {
        get_data: false
      },
      item_ids: [],
      batch_items: [],
      product_list: []
    }
  },

  async beforeMount() {
    // console.log(this.flash_sale)
    await this.m__get_data()
  },

  methods: {
    m__first_text() {
      if (this.flash_sale) {
        return `${this.dayjs(this.flash_sale.start_time * 1000).format('HH:mm DD-MM-YYYY')} - ${this.dayjs(this.flash_sale.end_time * 1000).format('HH:mm DD-MM-YYYY')}`
      } else {
        return ''
      }
    },

    m__second_text() {
      if (this.flash_sale) {
        return this.flash_sale.type === 3
          ? `${this.$t('base.ended_on')} ${this.dayjs(this.flash_sale.end_time * 1000).format('HH:mm DD-MM-YYYY')}`
          : `${this.$t('base.will_end_on')} ${this.dayjs(this.flash_sale.end_time * 1000).format('HH:mm DD-MM-YYYY')}`
      } else {
        return ''
      }
    },

    m__back_to_list() {
      this.$emit('m__back_to_list', false)
    },

    async m__get_item_ids() {
      if (!this.flash_sale) {
        return
      }

      this.item_ids = []
      const resp = await this.seller.flash_sale_get_item_ids(this.flash_sale.flash_sale_id)
      this.item_ids = resp.data.item_ids
    },

    async m__get_batch_items() {
      if (!this.flash_sale) {
        return
      }

      this.batch_items = []
      let offset = 0, limit = 100, count
      let batch_resp = await this.seller.flash_sale_get_batch_items(this.flash_sale.flash_sale_id, offset, limit)

      while (batch_resp.data.items && batch_resp.data.items.length) {
        for (const item of batch_resp.data.items) {
          const item_found = batch_resp.data.price_stock_info.find(i => i.item_id === item.item_id)
          const model_found = item_found.sku_stock_price_list.find(i => i.model_id === item.model_id)
          item.price = model_found.price_info.normal_price
          item.quantity = model_found.seller_stock_info.normal_stock
        }
        this.batch_items.push(...batch_resp.data.items)

        count += batch_resp.data.item_info.length
        if (count >= batch_resp.data.total_count) break

        offset += limit
        batch_resp = await this.seller.flash_sale_get_batch_items(this.flash_sale.flash_sale_id, offset, limit)
      }
    },

    async m__get_data() {
      this.loading.get_data = true
      await this.m__get_item_ids()
      await this.m__get_batch_items()

      if (this.item_ids.length) {
        this.product_list = []

        for (const item_id of this.item_ids) {
          const product_resp = await this.seller.get_product_detail(item_id)
          const i = product_resp.data.data.product_info
          i.model_list = i.model_list.reduce((result, ii) => {
            const batch = this.batch_items.find(iii => iii.model_id === ii.id)
            if (batch) {
              ii.batch = batch
              result.push(ii)
            }
            return result
          }, [])
          this.product_list.push({...i})
        }
      }

      this.loading.get_data = false
    }
  }
}
</script>

<style>
.disabled-text {
  color: #ccccd6 !important;
}

.table tr td {
  border-top: 1px solid white !important;
}
</style>




// WEBPACK FOOTER //
// src/pages/flash_sale/detail.vue